import React, { FC, useContext } from 'react'

import { FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material'
import { DataContext } from '../../contexts/DataProvider'

interface UserSelectProps {
  selectedUser: string
  handleSelect: (event) => void
}

const UserSelect: FC<UserSelectProps> = ({ selectedUser, handleSelect }) => {
  const { activeContract } = useContext(DataContext)

  const getUsers = activeContract?.users?.map(({ _id }) => (
    <MenuItem key={_id} value={_id}>
      {_id}
    </MenuItem>
  ))

  return (
    <Paper
      sx={{
        p: 2,
      }}
    >
      <FormControl fullWidth>
        <InputLabel id="user-select-label">Users</InputLabel>
        <Select
          labelId="user-select-label"
          id="user-select"
          defaultValue=""
          value={selectedUser || ''}
          label="Contract"
          onChange={handleSelect}
        >
          {getUsers}
        </Select>
      </FormControl>
    </Paper>
  )
}
export default UserSelect
